import React, { useEffect, useState } from 'react'
import { array, string, object, number } from 'prop-types'
import { List, ListSubheader } from '@mui/material'
import LinkItemList from './LinkItemList'
import { useLocation } from 'react-router-dom'
import PrivateRC from '../../PrivateRC'

const ListaMenu = ({ menus }) => {
  const [selectedIndex, setSelectedIndex] = useState(null)
  const location = useLocation()
  const handleListItemClick = index => {
    setSelectedIndex(index)
  }

  useEffect(() => {
    menus.forEach((item, index) => {
      if (item.path === location.pathname) {
        setSelectedIndex(index)
      }
    })
  }, [menus, location])

  const style = {
    background: 'transparent',
    textTransform: 'uppercase',
    color: 'white'
  }

  const HeaderList = ({ item }) => {
    return (
      <>
        <ListSubheader sx={style} component="div" id="nested-list-subheader">
          {item.title}
        </ListSubheader>
      </>
    )
  }

  HeaderList.propTypes = {
    item: object
  }

  const SwitchList = ({ item, index }) => {
    return (
      <>
        {'title' in item ? (
          <HeaderList item={item} />
        ) : (
          <PrivateRC roles={item.roles}>
            <LinkItemList
              item={item}
              index={index}
              selectedIndex={selectedIndex}
              handleListItemClick={handleListItemClick}
            />
          </PrivateRC>
        )}
      </>
    )
  }

  SwitchList.propTypes = {
    item: object,
    index: number
  }

  return (
    <List>
      {menus.map((item, index) => (
        <SwitchList item={item} index={index} key={index} />
      ))}
    </List>
  )
}
ListaMenu.propTypes = {
  menus: array,
  route: string
}

export default ListaMenu
